import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
const useUtilityProviderSetupV2Styles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  inlineTooltip: {
    marginLeft: '4px',
    padding: '0'
  },
  utilities: {
    marginTop: '8px',
    '& .MuiButton-utility': {
      marginRight: '10px',
      marginLeft: '0',
      marginTop: '10px'
    }
  },
  provider: {
    marginTop: '40px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    padding: '24px 40px 40px 40px'
  },
  providerTitle: {
    margin: '-24px -40px 0 -40px',
    padding: '24px 40px',
    background: palette.brandGradients.fade,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  providerActions: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiButton-root': {
      marginLeft: '10px'
    }
  },
  billsActions: {
    marginTop: '18px',
    display: 'flex',
    alignItems: 'center',
    '& .MuiToggleButtonGroup-root': {
      marginRight: '10px'
    }
  },
  glLoader: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '999',
    display: 'flex',
    fontSize: '18px',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.9)'
  },
  providerTitleAppfolio: {
    fontSize: '13px',
    '& b': {
      fontWeight: '600'
    }
  },
  providerTitleAppfolioModal: {
    color: palette.primary.main,
    cursor: 'pointer'
  }
}));
export default useUtilityProviderSetupV2Styles;